exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".multi-button-selector{background-color:#fff;text-align:center;border:1px solid #dedede;padding:15px 60px 10px;border-radius:10px}.multi-button-selector>button{margin:2px;border-radius:13px;color:#b8b8b8;font-size:15px;font-weight:400;padding-top:3px;padding-bottom:3px}.multi-button-selector>button.active{background-color:#0060c6;color:#fff}.multi-button-selector>button.active:active,.multi-button-selector>button.active:focus,.multi-button-selector>button.active:visited{text-decoration:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/features/commons/SearchBar/components/MultiButtonSelector/MultiButtonSelector.scss
// module id = 1104
// module chunks = 0